module.exports = __webpack_public_path__ + "static/media/drop-6@1x.242efd4d.png";